export default "__VITE_ASSET__prVBwQOd__"